const API_URL = 'https://netlify.blacklemon.dk/.netlify/functions/';
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data,
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      // We'll create the event dynamically with the quantity value
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));
    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Prevent rapid successive calls (e.g., double-clicks or event bubbling)
      const now = Date.now();
      const lastCallKey = `lastChange_${change > 0 ? 'plus' : 'minus'}`;
      if (this[lastCallKey] && (now - this[lastCallKey]) < 100) {
        return;
      }
      this[lastCallKey] = now;

      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > quantity + change) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < quantity + change) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, this.input.min);

      // CRITICAL: Capture the target quantity BEFORE updating the input
      // This ensures that even if multiple events fire, each carries its own
      // intended quantity value, preventing race conditions where a delayed
      // event reads the wrong value after another event has updated the input.
      const targetQuantity = quantity;

      // Output number
      this.input.value = targetQuantity;

      // Create a CustomEvent with the target quantity in detail
      // This way, onChange can read the intended quantity from the event,
      // not from the input value (which may have changed by the time it processes)
      const changeEvent = new CustomEvent('change', {
        bubbles: true,
        detail: {
          quantity: targetQuantity,
          timestamp: now,
        },
      });

      this.input.dispatchEvent(changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');
    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additionalImages = this.querySelectorAll('.product-secondary-image');
      this.additionalImagesNav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quickAdd = this.querySelector('.product-card--add-to-cart-button-simple');
      this.cartDrawer = document.getElementById('Cart-Drawer');
      this.quantitySelector = this.querySelector('quantity-selector');
      this.debouncedOnChange = this.debounce((event) => {
        this.onChangeQuantity(event);
      }, 500);
    }
    connectedCallback() {
      if (this.swatches) this.enableSwatches(this.swatches, this.image);
      if (this.additionalImages.length) this.enableAdditionalImages();
      if (this.quickAdd) {
        this.MixMatch = this.quickAdd.dataset.isMixAndMatch === 'true';
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_container = this.querySelector('.product-featured-image');
      let imageLength = this.additionalImages.length;
      let images = this.additionalImages;
      let nav = this.additionalImagesNav;
      const mousemove = function (e) {
        if (window.innerWidth <= 768) {
          return;
        }
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * imageLength);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }
      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true,
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true,
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true,
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true,
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true,
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true,
        });
      }
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '',
        active = swatches.querySelector('.product-card-swatch.active');

      swatch_list.forEach((swatch, index) => {
        swatch.addEventListener('mouseover', function () {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.checkQuantityInCart();
      this.quickAdd.addEventListener('click', this.quickAddToCart.bind(this));
    }

    async getCartItems() {
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error('Failed to fetch cart');
        const cart = await response.json();
        return cart.items || [];
      } catch (error) {
        console.error('Error fetching cart:', error);
        return [];
      }
    }

    async getCartItemsFromMixAndMatch(items) {
      return items
        .filter((item) => {
          const itemProperties = item.properties;
          if (!itemProperties) return;
          const wasItAddedInMixAndMatch = itemProperties['_mix_match_enabled'];
          if (!wasItAddedInMixAndMatch) return;
          const wasItAddedInMixAndMatchVal = wasItAddedInMixAndMatch === 'true' || false;
          if (!wasItAddedInMixAndMatchVal) return;
          return item;
        })
    }

    async checkQuantityInCart() {
      if (!this.quantitySelector) return;
      const input = this.quantitySelector.querySelector('input');
      const productVariantId = parseInt(this.quickAdd.dataset.productId);
      const cartItems = await this.getCartItems();

      const cartItemsFromMixAndMatch = await this.getCartItemsFromMixAndMatch(cartItems);
      const productInCart = cartItemsFromMixAndMatch.find((item) => item.variant_id === productVariantId);
      this.quickAdd.classList.toggle('is-hidden', !!productInCart);
      this.quantitySelector.classList.toggle('is-hidden', !productInCart);
      this.classList.toggle('is-active', !!productInCart);
      if (productInCart && input) input.value = productInCart.quantity;

      input.addEventListener('change', this.debouncedOnChange);
    }

    async onChangeQuantity(event) {
      this.quantitySelector.classList.add('loading');
      const quantity = event.target.value;
      const productVariantId = parseInt(this.quickAdd.dataset.productId);
      const cartItems = await this.getCartItems();
      const productInCart = cartItems.find((item) => item.variant_id === productVariantId);
      if (productInCart && productInCart.quantity !== quantity) {
        this.updateQuantity(productInCart.key, quantity);
      } else {
        this.quantitySelector.classList.remove('loading');
      }
    }

    updateQuantity(id, quantity) {
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        ...{
          body: JSON.stringify({
            id,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
          }),
        },
      };

      try {
        fetch(`${theme.routes.cart_change_url}`, options)
          .then((response) => {
            if (!response.ok) throw new Error('Failed to update quantity');
            return response.json();
          })
          .then((response_1) => {
            this.renderContents(response_1);
          })
          .finally(() => {
            this.checkQuantityInCart();
            this.quantitySelector.classList.remove('loading');
          });
      } catch (e) {
        console.error(e);
        this.quantitySelector.classList.remove('loading');
      }
    }

    async quickAddToCart(evt) {
      evt.preventDefault();
      if (this.quickAdd.disabled) return;

      const addToCartButtons = document.querySelectorAll('.mix-and-match-modal__content-info-list product-card .product-card--add-to-cart-button-simple');
      this.disableQuickAddButtons(addToCartButtons);
      this.quickAdd.classList.add('loading');
      this.quickAdd.setAttribute('aria-disabled', true);

      let quantity = 1;
      const quantitySelectorTemplate = this.querySelector('template#mix-and-match-quantity-selector');
      if (quantitySelectorTemplate) {
        quantity = quantitySelectorTemplate.content.querySelector('quantity-selector')?.input?.value;
      }
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quickAdd.dataset.productId);
      formData.append('quantity', quantity);
      formData.append(
        'sections',
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append('sections_url', window.location.pathname);

      if (this.MixMatch) formData.append('properties[_mix_match_enabled]', 'true');
      let productVariantId = formData.get('id');
      let hasFreeGift = false;

      if (productVariantId) {
        productVariantId = parseInt(productVariantId);
        const getCart = await Shopify.functions.getCart();

        if (getCart.items) {
          const freeGiftProducts = window.theme.settings.free_gift_products;

          let isFreeGiftProduct = freeGiftProducts.some((product) => product.variants && product.variants.some((variant) => variant.id === productVariantId));

          if (isFreeGiftProduct) {
            const freeGifts = getCart.items.filter((item) => item.discounts.some((discount) => discount.title === window.theme.settings.free_gift && discount.amount > 0));

            hasFreeGift = freeGifts.length > 0;
            if (hasFreeGift) {
              this.quickAdd.classList.remove('loading');
              this.quickAdd.removeAttribute('aria-disabled');
              return;
            }
          }
        }
      }

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quickAdd.classList.remove('loading');
          this.quickAdd.removeAttribute('aria-disabled');
          this.checkQuantityInCart();
          this.enableQuickAddButtons(addToCartButtons);
        });
      return false;
    }

    disableQuickAddButtons(addToCartButtons) {
      if (!addToCartButtons) return;
      addToCartButtons.forEach((btn) => {
        btn.disabled = true;
        btn.classList.add('loading');
      });
    }

    enableQuickAddButtons(addToCartButtons) {
      if (!addToCartButtons) return;
      addToCartButtons.forEach((btn) => {
        btn.disabled = false;
        btn.classList.remove('loading');
      });
    }

    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form',
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer',
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count',
        },
      ];
    }

    initPopper() {
      const button = this.cartDrawer.querySelector('.free-shipping--percentage-tracker');
      const tooltip = this.cartDrawer.querySelector('.free-shipping--text');
      const popperInstance = Popper.createPopper(button, tooltip, {
        placement: 'top',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
          {
            name: 'preventOverflow',
            options: {
              padding: 10,
            },
          },
          {
            name: 'flip',
            options: {
              fallbackPlacements: ['top'],
            },
          },
        ],
      });
      return popperInstance;
    }

    renderContents(parsedState) {
      let isCartDrawerInitialized = false;
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          if (!isCartDrawerInitialized) {
            new CartDrawer();
            isCartDrawerInitialized = true;
          }
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      });

      if (!this.MixMatch && document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }

        dispatchCustomEvent('cart-drawer:open');

        const styles = window.getComputedStyle(this.cartDrawer);
        const animationDuration = parseFloat(styles.transitionDuration + 0.1) * 1000;
        setTimeout(() => {
          this.initPopper();
        }, animationDuration);
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  customElements.define('product-card', ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector('.header-section'),
      header_main = document.getElementById('header'),
      menu = document.getElementById('mobile-menu'),
      toggle = document.querySelector('.mobile-toggle-wrapper'),
      setHeaderOffset = this.setHeaderOffset,
      setAnnouncementHeight = this.setAnnouncementHeight,
      setHeaderHeight = this.setHeaderHeight;

    if (!header_main) {
      return;
    }
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          toggle.removeAttribute('open');
          toggle.classList.remove('active');
        }
      }
    });
    toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
      setAnnouncementHeight(header);
      if (toggle.classList.contains('active')) {
        e.preventDefault();
        document.body.classList.remove('overflow-hidden');
        toggle.classList.remove('active');
        this.closeAnimation(toggle);
      } else {
        document.body.classList.add('overflow-hidden');
        setTimeout(() => {
          toggle.classList.add('active');
        });
      }
      window.dispatchEvent(new Event('resize.resize-select'));
    });

    // Mobile Menu offset
    window.addEventListener(
      'scroll',
      function () {
        setHeaderOffset(header);
        setHeaderHeight(header_main);
        // Sticky Header Class
        if (header_main.classList.contains('header-sticky--active')) {
          let offset = header_main.offsetTop;

          header_main.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
        }
      },
      {
        passive: true,
      }
    );
    window.dispatchEvent(new Event('scroll'));

    if (document.querySelector('.announcement-bar-section')) {
      const a_bar = document.querySelector('.announcement-bar-section');
      window.addEventListener(
        'resize',
        function () {
          setAnnouncementHeight(a_bar);
        },
        {
          passive: true,
        }
      );
      window.dispatchEvent(new Event('resize'));
    }
    // Buttons.
    menu.querySelectorAll('summary').forEach((summary) => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    menu.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }
  setAnnouncementHeight(a_bar) {
    let h = a_bar.clientHeight;
    document.documentElement.style.setProperty('--announcement-height', h + 'px');
  }
  setHeaderOffset() {
    const a_bar = document.querySelector('.announcement-bar-section');
    if (!a_bar) return;
    let h = a_bar.clientHeight;
    document.documentElement.style.setProperty('--header-offset', h + 'px');
  }
  setHeaderHeight(header) {
    let h = header.clientHeight;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.link-container');
    const isOpen = detailsElement.hasAttribute('open');

    setTimeout(() => {
      detailsElement.classList.add('menu-opening');
      parentMenuElement && parentMenuElement.classList.add('submenu-open');
    }, 100);
  }
  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        detailsElement.querySelectorAll('details').forEach((details) => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
          details.classList.remove('submenu-open');
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
document.addEventListener('DOMContentLoaded', () => {
  const stickyElement = document.querySelector('.announcement-bar.fixed');
  const announcementSection = document.querySelector('.announcement-bar-section');
  const headerElement = document.querySelector('.header-sticky--active');

  if (announcementSection) {
    if (stickyElement) {
      announcementSection.classList.add('announcement-bar-is-fixed');
      if (headerElement) {
        headerElement.classList.add('header-is-fixed');
      }
    } else {
      announcementSection.classList.remove('announcement-bar-is-fixed');
      if (headerElement) {
        headerElement.classList.remove('header-is-fixed');
      }
    }
  }
});
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener(
        'resize',
        debounce(function () {
          _this.resizeSubMenus();
        }, 100)
      );

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e.target.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer')) {
        this.close_quick_view(panel);
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view(panel) {
      panel = panel ? panel : document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */

// Global listener tracking to avoid stacking
window.__donationListenerAttached = window.__donationListenerAttached || false;

class CartDrawer {
  constructor() {
    this.container = document.getElementById('Cart-Drawer');
    if (!this.container) {
      return;
    }
    this.marketLanguage = this.container.getAttribute('data-market-language');
    // Single bound handler to keep donation logic in sync with cart changes
    this.boundUpdateDonationInCart = this.handleDonationUpdate.bind(this);
    // Track in-flight quantity changes per line to avoid duplicate
    // identical change requests being sent in quick succession.
    this.pendingLineChanges = {};
    this.handleDonationInCart();
    this.getCustomerCredits();
    let button = document.getElementById('cart-drawer-toggle');

    // Add functionality to buttons
    button.addEventListener('click', (event) => {
      event.preventDefault();
      this.onCartOpen();
    });

    document.addEventListener('open:cart-drawer', (e) => {
      this.onCartOpen();
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.init();

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
    this.termsCheckbox();
  }

  getSectionsToRender() {
    return [
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer',
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count',
      },
    ];
  }

  async getCustomerCredits() {
    const customerId = this.container?.dataset?.customerId;
    if (!customerId) return;

    try {
      const storeCredits = await this.fetchCustomerStoreCredits(customerId);
      if (!storeCredits) return;
      this.renderStoreCreditsWidget(storeCredits);
    } catch (error) {
      console.error('Error getting customer store credits:', error);
    }
  }

  async fetchCustomerStoreCredits(customerId) {
    try {
      const response = await fetch(`${API_URL}/getCustomerStoreCredits?customerId=${customerId}&store=${window.theme.settings.store_name}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data && data.storeCredits) {
        return data.storeCredits.find((storeCredit) => storeCredit.currencyCode === window.theme.settings.currency_code);
      }
      return null;
    } catch (error) {
      console.error('Error fetching customer store credits:', error);
      return null;
    }
  }

  renderStoreCreditsWidget(currentStoreCredits) {
    const storeCreditsWidget = this.container.querySelector('.store-credits__wrapper');
    if (!storeCreditsWidget || !currentStoreCredits) return;

    const storeCreditsThreshold = storeCreditsWidget?.dataset?.storeCreditsThreshold;
    if (!storeCreditsThreshold) return;

    let balance = currentStoreCredits.balance;
    if (parseInt(balance, 10) < parseInt(storeCreditsThreshold, 10)) {
      return;
    }

    const currencyCode = currentStoreCredits.currencyCode;
    if (currencyCode !== window.theme.settings.currency_code) {
      storeCreditsWidget.remove();
      return;
    }

    let format = window.theme.settings.money_with_currency_format || '';
    if (balance) {
      if (balance.includes(".")) {
        balance = balance.split(".")[0];
      }
      const balanceFormatted = parseInt(balance, 10) * 100;
      const formattedBalance = formatMoney(balanceFormatted, format);
      const storeCreditsWidgetPrice = storeCreditsWidget.querySelector('.store-credits__price');
      if (storeCreditsWidgetPrice) {
        storeCreditsWidgetPrice.innerHTML = formattedBalance;
      }
      storeCreditsWidget.classList.remove('hidden');
    }
  }

  async handleDonationInCart() {
    const donationVariantId = this.container.querySelector('.donation-line-item')?.dataset.donationVariantId;
    this.disableCheckoutBtn();
    const cart = await fetch('/cart.js').then((r) => r.json());

    // Handle donation in cart for non-Danish markets
    if (this.marketLanguage !== 'da') {
      this.enableCheckoutBtn();
      const hasDonation = cart?.items.some((item) => item.variant_id === Number(donationVariantId));
      if (hasDonation) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: donationVariantId,
            quantity: 0,
          }),
        });
      }
      return;
    }
    // Update the donation in cart for Danish market
    await this.updateDonationInCart(cart);

    // Keep donation product in sync on every cart line update
    // while avoiding stacking multiple listeners.
    if (!window.__donationListenerAttached) {
      document.addEventListener('line-item:update', this.boundUpdateDonationInCart);
      window.__donationListenerAttached = true;
    }

    let donationDisabled = false;
    if (!donationVariantId) donationDisabled = true;
    else localStorage.setItem('donationVariantId', donationVariantId);

    if (donationDisabled && localStorage.getItem('isDonationDisabledTriggered') === 'false') {
      localStorage.setItem('isDonationDisabledTriggered', true);
      const donationVariantIdOld = localStorage.getItem('donationVariantId');
      const donationItemIndex = cart.items.findIndex((item) => item.variant_id === Number(donationVariantIdOld));

      if (donationItemIndex > -1) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: donationItemIndex + 1,
            quantity: 0,
          }),
        });
        localStorage.removeItem('donationVariantId');
      }
      await this.updateCarDrawerDOM();
    }
  }

  async updateDonationInCart(cart) {
    const donationVariantId = this.container.querySelector('.donation-line-item')?.dataset.donationVariantId;
    if (!donationVariantId) {
      this.enableCheckoutBtn();
      return;
    }

    // Ensure we always have a fresh cart when needed
    if (!cart) {
      cart = await fetch('/cart.js').then((r) => r.json());
    }

    const hasDonation = cart?.items.some((item) => item.variant_id === Number(donationVariantId));
    const nonDonationItems = cart?.items.filter((item) => item.variant_id !== Number(donationVariantId));
    
    // Check if any non-donation items require shipping
    // Only proceed if there are non-donation items
    if (!nonDonationItems || nonDonationItems.length === 0) {
      // If cart is empty or only has donation, remove donation if it exists
      if (hasDonation) {
        const donationItemIndex = cart?.items.findIndex((item) => item.variant_id === Number(donationVariantId));
        if (donationItemIndex > -1) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: donationItemIndex + 1,
              quantity: 0,
            }),
          });
          await this.updateCarDrawerDOM();
        }
      }
      this.enableCheckoutBtn();
      return;
    }

    // First, check if ALL items are digital (none require shipping)
    // This is the primary check - if all items are digital, we should NEVER add donation
    const allItemsAreDigital = nonDonationItems.length > 0 && 
      nonDonationItems.every((item) => {
        // Item is digital if requires_shipping is false, null, undefined, or not true
        return item.requires_shipping !== true;
      });

    // If all items are digital, remove donation if it exists and exit early
    if (allItemsAreDigital) {
      if (hasDonation) {
        const donationItemIndex = cart?.items.findIndex((item) => item.variant_id === Number(donationVariantId));
        if (donationItemIndex > -1) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: donationItemIndex + 1,
              quantity: 0,
            }),
          });
          await this.updateCarDrawerDOM();
        }
      }
      this.enableCheckoutBtn();
      return;
    }

    // Check if any non-donation items require shipping
    // Digital products have requires_shipping === false
    // Physical products have requires_shipping === true
    const hasItemsRequiringShipping = nonDonationItems.some((item) => {
      // Explicitly check for true - anything else (false, null, undefined) means no shipping
      return item.requires_shipping === true;
    });

    // CRITICAL: Never add donation if all items are digital
    // Only add donation if there are items requiring shipping AND we're sure not all items are digital
    if (!hasDonation && hasItemsRequiringShipping && !allItemsAreDigital && nonDonationItems.length > 0) {
      // Add donation product
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: donationVariantId,
          quantity: 1,
        }),
      });
      
      // Verify the cart state after adding - if all items are still digital, remove it immediately
      const updatedCart = await fetch('/cart.js').then((r) => r.json());
      const updatedNonDonationItems = updatedCart?.items.filter((item) => item.variant_id !== Number(donationVariantId));
      const stillAllDigital = updatedNonDonationItems.length > 0 && 
        updatedNonDonationItems.every((item) => item.requires_shipping !== true);
      
      if (stillAllDigital) {
        // Remove donation immediately if all items are still digital
        const donationItemIndex = updatedCart?.items.findIndex((item) => item.variant_id === Number(donationVariantId));
        if (donationItemIndex > -1) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: donationItemIndex + 1,
              quantity: 0,
            }),
          });
        }
      }
      
      await this.updateCarDrawerDOM();
    } else if (hasDonation && (!hasItemsRequiringShipping || allItemsAreDigital)) {
      // Remove donation product if no items require shipping (all digital)
      const donationItemIndex = cart?.items.findIndex((item) => item.variant_id === Number(donationVariantId));
      if (donationItemIndex > -1) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: donationItemIndex + 1,
            quantity: 0,
          }),
        });
        await this.updateCarDrawerDOM();
      }
      this.enableCheckoutBtn();
      return;
    }

    // At this point, we have at least one item requiring shipping and
    // the donation should stay in the cart. Enforce exactly one donation
    // line with quantity 1 — handle duplicate lines that can appear when
    // Shopify splits the variant across multiple lines (different properties,
    // selling_plan, or racing /cart/add.js calls).
    let latestCart = await fetch('/cart.js').then((r) => r.json());
    let donationLineNumbers = [];
    latestCart?.items.forEach((item, index) => {
      if (item.variant_id === Number(donationVariantId)) donationLineNumbers.push(index + 1);
    });

    if (donationLineNumbers.length > 1) {
      // Remove extras from highest line index to lowest to avoid reindexing issues.
      const extras = donationLineNumbers.slice(1).sort((a, b) => b - a);
      for (const line of extras) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: 0 }),
        });
      }
      latestCart = await fetch('/cart.js').then((r) => r.json());
      donationLineNumbers = [];
      latestCart?.items.forEach((item, index) => {
        if (item.variant_id === Number(donationVariantId)) donationLineNumbers.push(index + 1);
      });
    }

    if (donationLineNumbers.length === 1) {
      const line = donationLineNumbers[0];
      const donationItem = latestCart.items[line - 1];
      if (donationItem && donationItem.quantity !== 1) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: 1 }),
        });
      }
    }

    await this.updateCarDrawerDOM();
    this.enableCheckoutBtn();
  }

  disableCheckoutBtn() {
    const checkoutBtn = document.querySelector('#checkoutForm .checkout');
    if (!checkoutBtn) return;
    checkoutBtn.disabled = true;
    checkoutBtn.classList.add('disabled');
  }

  enableCheckoutBtn() {
    const checkoutBtn = document.querySelector('#checkoutForm .checkout');
    if (!checkoutBtn) return;
    checkoutBtn.disabled = false;
    checkoutBtn.classList.remove('disabled');
  }

  async updateCarDrawerDOM() {
    const updatedDocument = await fetch('/cart').then((r) => r.text());
    const parser = new DOMParser();
    const doc = parser.parseFromString(updatedDocument, 'text/html');
    const cartIcon = doc.getElementById('cart-drawer-toggle');
    const newDrawer = doc.querySelector('#Cart-Drawer');
    if (newDrawer && cartIcon) {
      document.querySelector('#Cart-Drawer').innerHTML = newDrawer.innerHTML;
      document.querySelector('#cart-drawer-toggle').innerHTML = cartIcon.innerHTML;

      document.removeEventListener('line-item:update', this.boundUpdateDonationInCart);
      window.__donationListenerAttached = false;
    }
    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
    this.termsCheckbox();
  }

  async handleEmptyCart(data) {
    const donationVariantId = this.container.querySelector('.donation-line-item')?.dataset.donationVariantId;
    if (!donationVariantId) return;

    const cartItems = data?.detail?.cart?.items;
    if (!cartItems || cartItems.length === 0) return;

    const hasDonation = cartItems.some((item) => item.variant_id === Number(donationVariantId));
    const nonDonationItems = cartItems.filter((item) => item.variant_id !== Number(donationVariantId));

    if (nonDonationItems && nonDonationItems.length === 0 && hasDonation) {
      // If only the donation is left in cart, let the main
      // donation updater handle removal logic instead.
      await this.updateDonationInCart({ items: cartItems });
    }
  }

  // Keep donation product in sync whenever a line item updates
  async handleDonationUpdate(event) {
    const cartFromEvent = event?.detail?.cart;
    await this.updateDonationInCart(cartFromEvent);
  }

  onCartOpen() {
    document.body.classList.add('open-cc');
    document.body.classList.add('open-cart');
    this.container.classList.add('active');
    this.container.focus();
    setTimeout(() => {
      if (this.container.querySelector('.product-recommendations--full')) {
        this.container.querySelector('.product-recommendations--full').classList.add('active');
      }
    });
    dispatchCustomEvent('cart-drawer:open');

    const styles = window.getComputedStyle(this.container);
    const animationDuration = parseFloat(styles.transitionDuration + 0.1) * 1000;
    setTimeout(() => {
      this.initPopper();
    }, animationDuration);
  }

  async init() {
    let parsedState = await Shopify.functions.getCart();
    const itemsToRemove = this.findItemsToRemove(parsedState);
    if (itemsToRemove && itemsToRemove.length > 0) parsedState = await this.removeItemsToRemove(itemsToRemove);
  }

  initPopper() {
    const button = this.container.querySelector('.free-shipping--percentage-tracker');
    const tooltip = this.container.querySelector('.free-shipping--text');
    const popperInstance = Popper.createPopper(button, tooltip, {
      placement: 'top',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            padding: 10,
          },
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top'],
          },
        },
      ],
    });
    return popperInstance;
  }

  onChange(event) {
    if (event.target.classList.contains('qty')) {
      const line = event.target.dataset.index;
      // CRITICAL: Read quantity from event.detail if available (from our CustomEvent)
      // This captures the intended quantity at the moment the event was dispatched,
      // not the current input value (which may have changed if another event processed first)
      // Fall back to event.target.value for native change events (e.g., user typing)
      const value = event.detail?.quantity ?? event.target.value;
      
      // Prevent processing the same event object twice
      if (event._processedByCartDrawer) {
        return;
      }
      event._processedByCartDrawer = true;
      
      // Synchronous guard: prevent duplicate onChange processing before updateQuantity
      // This must happen BEFORE updateQuantity's atomic check to catch duplicates earlier
      // Use timestamp-based tracking to catch events that fire within the same millisecond
      const now = Date.now();
      const onChangeKey = `${line}-${value}`;
      if (!this._onChangeProcessing) this._onChangeProcessing = new Map();
      
      const lastProcessed = this._onChangeProcessing.get(onChangeKey);
      // Reject if same line+quantity was processed within last 100ms
      // This catches events that fire in rapid succession (even same millisecond)
      if (lastProcessed && (now - lastProcessed) < 100) {
        return;
      }
      
      // Mark as processing immediately (synchronously) with timestamp
      // This must happen BEFORE calling updateQuantity to prevent race conditions
      this._onChangeProcessing.set(onChangeKey, now);
      
      // Call updateQuantity - it has its own atomic check as a second layer of defense
      this.updateQuantity(line, value).finally(() => {
        // Clear the processing flag after updateQuantity completes
        // Use a small delay to ensure the atomic check in updateQuantity has time to set its own flag
        setTimeout(() => {
          this._onChangeProcessing.delete(onChangeKey);
        }, 200);
      });
    }
  }

  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        event.preventDefault();
        this.updateQuantity(event.target.dataset.index, '0');
        remove.removeEventListener('click', () => { });
      });
    });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  termsCheckbox() {
    const _this = this;
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkoutButton = this.container.querySelector('.button.checkout');

    if (checkoutButton) {
      if (terms_checkbox != undefined) terms_checkbox.setCustomValidity(theme.strings.requiresTerms);

      checkoutButton.addEventListener('click', async function (e) {
        if (terms_checkbox != undefined) {
          if (!terms_checkbox.checked) {
            terms_checkbox.reportValidity();
            terms_checkbox.focus();
            e.preventDefault();
            return;
          }
        }
        const freeGiftForm = _this.container.querySelector('free-gift-form');
        if (freeGiftForm) {
          const fieldset = freeGiftForm.querySelector('fieldset.product-cart-free-gifts');
          if (fieldset) {
            const firstInput = fieldset.querySelector('input[name="free_gifts"]');
            if (firstInput) {
              e.preventDefault();
              try {
                await _this.addFreeItemToCart(firstInput);
                _this.container.querySelector('form#checkoutForm')?.submit();
              } catch (error) {
                console.error('Error adding free item to cart:', error);
              }
              return;
            }
          }
        }
        _this.container.querySelector('form#checkoutForm')?.submit();
      });
    }
  }

  addFreeItemToCart(inputElement) {
    return new Promise((resolve, reject) => {
      const onCartItemAdded = (e) => {
        if (e.detail && e.detail.product) {
          document.removeEventListener('cart:item-added', onCartItemAdded); // Clean up the event listener
          resolve();
        }
      };

      document.addEventListener('cart:item-added', onCartItemAdded);
      inputElement.click();

      // Reject the promise if the free item is not added to the cart in 8 seconds
      setTimeout(() => {
        document.removeEventListener('cart:item-added', onCartItemAdded);
        reject(new Error('Free item not added to cart in time'));
      }, 8000);
    });
  }

  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`,
      },
      body: JSON.stringify({
        note: document.getElementById('mini-cart__notes').value,
      }),
    });
  }

  updateFreeShipping() {
    const freeShipping = this.container.querySelector('.free-shipping');
    if (!freeShipping) return;

    let freeShippingTextEl = freeShipping.querySelector('.free-shipping--text');
    let amountText = freeShippingTextEl?.querySelector('span');
    let total = parseInt(freeShipping.dataset.cartTotal, 10);
    let giftMinimum = Math.round(parseInt(freeShipping.dataset.giftMinimum, 10));
    let shippingMinimum = Math.round(parseInt(freeShipping.dataset.shippingMinimum, 10));

    // Set minimum and maximum based on which is greater
    let minimum = Math.min(giftMinimum, shippingMinimum);
    let maximum = Math.max(giftMinimum, shippingMinimum);

    let remaining = 0;
    let percentage = 1;

    if (total < maximum) {
      if (total < minimum) {
        remaining = minimum - total;
        // First 50% of progress until reaching minimum
        percentage = (maximum * 0.5 * (total / minimum)) / maximum;
      } else {
        // First threshold is met, so we start at 50%
        // The rest (total - minimum) progresses towards the second 50%
        remaining = maximum - total;
        percentage = 0.5 + ((total - minimum) / (maximum - minimum)) * 0.5;
      }
    }

    let format = window.theme.settings.money_with_currency_format || '{{amount}} kr.';
    if (amountText) {
      amountText.innerHTML = formatMoney(remaining, format);
    }

    const midEl = freeShipping.querySelector('.free-shipping--mid');
    if (midEl) {
      if (total >= minimum) {
        midEl.classList.add('active');
      } else {
        midEl.classList.remove('active');
      }
    }

    const endEl = freeShipping.querySelector('.free-shipping--end');
    if (endEl) {
      if (total > minimum && total >= maximum) {
        endEl.classList.add('active');
      } else {
        endEl.classList.remove('active');
      }
    }

    let giftPercentage = giftMinimum / maximum;
    let shippingPercentage = shippingMinimum / maximum;

    freeShipping.style.setProperty('--gift-percentage', giftPercentage);
    freeShipping.style.setProperty('--shipping-percentage', shippingPercentage);
    freeShipping.style.setProperty('--percentage', percentage);

    this.initPopper();
  }

  async updateQuantity(line, quantity) {
    // CRITICAL: Atomic check-and-set MUST happen FIRST, before any DOM operations
    // to prevent race conditions when multiple onChange events fire simultaneously.
    const changeKey = String(line || '');
    const quantityStr = String(quantity);
    
    if (!this.pendingLineChanges) this.pendingLineChanges = {};
    
    // Atomic check: if pending exists with same quantity, skip immediately
    const lastChange = this.pendingLineChanges[changeKey];
    if (lastChange && lastChange.quantity === quantityStr && lastChange.pending) {
      return;
    }
    
    // Atomic set: mark as pending immediately, before any DOM or async operations
    this.pendingLineChanges[changeKey] = {
      quantity: quantityStr,
      pending: true,
      timestamp: Date.now(),
    };

    // Now safe to do DOM operations
    const cartDrawerItem = this.container.querySelector(`#CartDrawerItem-${line}`);
    if (cartDrawerItem) cartDrawerItem.classList.add('thb-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity,
    });

    const productRecommendations = this.container.querySelector('.product-recommendations--full');
    if (productRecommendations) productRecommendations.classList.remove('active');

    try {
      const response = await fetch(theme.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: body,
      });

      if (!response.ok) throw new Error('Failed to update cart');

      let parsedState = await response.json();
      
      // Check if cart structure changed (e.g., Shopify split lines for 3-for-2 discount)
      // If so, invalidate any pending duplicate requests that might target stale line numbers
      const originalLineItem = parsedState?.items?.find((item, idx) => String(idx + 1) === changeKey);
      const cartStructureChanged = !originalLineItem || originalLineItem.quantity !== parseInt(quantityStr, 10);
      
      // If cart structure changed (lines were split/merged), clear pending changes
      // to prevent duplicate requests targeting stale line numbers
      if (cartStructureChanged && this.pendingLineChanges) {
        delete this.pendingLineChanges[changeKey];
      }

      const freeShipping = this.container.querySelector('.free-shipping');
      if (freeShipping) {
        freeShipping.dataset.cartTotal = parsedState.items_subtotal_price || 0;
      }

      const itemsToRemove = this.findItemsToRemove(parsedState);
      if (itemsToRemove && itemsToRemove.length > 0) {
        const updatedState = await this.removeItemsToRemove(itemsToRemove);
        if (updatedState) {
          parsedState = updatedState;
        }
      }

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

        if (elementToReplace && parsedState?.sections?.[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }
      });

      this.removeProductEvent();
      this.notesToggle();
      this.termsCheckbox();
      this.updateFreeShipping();
      this.getCustomerCredits();

      dispatchCustomEvent('line-item:change:end', {
        quantity: quantity,
        cart: parsedState,
      });

      dispatchCustomEvent('line-item:update', {
        quantity: quantity,
        cart: parsedState,
      });
    } catch (error) {
      console.error('[CartDrawer] Error updating cart:', error, {
        line: changeKey,
        quantity: String(quantity),
      });
    } finally {
      // Only clear pending if it still exists and matches (cart structure might have changed)
      if (this.pendingLineChanges && this.pendingLineChanges[changeKey]) {
        if (this.pendingLineChanges[changeKey].quantity === quantityStr) {
          this.pendingLineChanges[changeKey].pending = false;
        } else {
          // Line number or quantity changed - remove the stale entry
          delete this.pendingLineChanges[changeKey];
        }
      }
      if (cartDrawerItem) cartDrawerItem.classList.remove('thb-loading');
    }
  }

  findItemsToRemove(parsedState) {
    try {
      const freeShipping = this.container.querySelector('.free-shipping');
      if (!freeShipping) {
        return [];
      }

      const giftMinimum = Math.round(parseInt(freeShipping.dataset.giftMinimum, 10) || 0);

      if (parsedState.items_subtotal_price >= giftMinimum) {
        return [];
      }

      const giftItems = Array.from(this.container.querySelectorAll('[data-free-gift]'));

      const itemsToRemove = [];

      if (parsedState.items) {
        giftItems.forEach((giftItem) => {
          const possibleIds = [giftItem.id.replace('CartDrawerItem-', ''), giftItem.dataset.id, giftItem.dataset.variantId, giftItem.querySelector('[name="id"]')?.value].filter(Boolean);

          const cartItem = parsedState.items.find((item) => possibleIds.some((id) => item.key === id || item.id.toString() === id || item.variant_id?.toString() === id));

          if (cartItem) {
            itemsToRemove.push(cartItem.key);
          }
        });
      }

      return itemsToRemove;
    } catch (error) {
      return [];
    }
  }

  async removeItemsToRemove(itemsToRemove) {
    try {
      if (!itemsToRemove || itemsToRemove.length === 0) {
        return null;
      }

      const sections = this.getSectionsToRender().map((section) => section.section);

      const removePromises = itemsToRemove.map(async (itemKey) => {
        try {
          const result = await Shopify.functions.removeItem(itemKey, {
            sections: sections,
            sections_url: window.location.pathname,
          });
          return result;
        } catch (error) {
          return null;
        }
      });

      const results = await Promise.all(removePromises);

      const validResults = results.filter((result) => result !== null);

      const finalResult = validResults[0] || null;

      return finalResult;
    } catch (error) {
      return null;
    }
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.closeButtons = this.querySelectorAll('[id^="ModalClose-"]');
    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.hide();
        if (button.dataset.openCartDrawer) {
          // trigger a custom event
          dispatchCustomEvent('open:cart-drawer');
        }
      });
    });
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.hide();
      }
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-localization-forms').forEach((localization) => {
      localization.addEventListener('change', (e) => {
        localization.querySelector('form').submit();
      });
    });
  }
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET',
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle,
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() { }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        setTimeout(() => {
          this.prepareAnimations();
          this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
        }, 400);
      }
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'sine.inOut',
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = 'hidden';
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = '';
        },
      });

      this.tl.fromTo(
        _this.details,
        {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height',
        },
        {
          duration: 0.6,
          height: final_height,
          clearProps: 'height',
        }
      );

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      e.preventDefault();
      if (this.tl.reversed()) {
        this.tl.timeScale(1).play();
      } else {
        this.tl.timeScale(3).reverse();
      }
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}
/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof recentIds !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof Localization !== 'undefined') {
    new Localization();
  }
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof Header !== 'undefined') {
    new Header();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});
